// Overview.js
import React, { useState, useReducer, useEffect } from "react";
import { Box, Container, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useParams } from "react-router-dom";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import TemplateBox from "components/TemplateBox";

import CaseDetailsContent from "../CaseDetailsContent";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CallSplitIcon from "@mui/icons-material/CallSplit";

import { fetchCase } from "layouts/cases/apiService";
function CaseDetailsFullscreen() {
  const { caseID } = useParams();
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );
  const [showPopup, setShowPopup] = useState(false);

  const handlePopUpButtonClick = () => {
    setShowPopup(!showPopup);
  };

  const theme = useTheme();
  const mobileDevice = !useMediaQuery(theme.breakpoints.up("md"));

  const initialState = {
    data: null,
    loading: true,
    error: null,
  };

  function reducer(state, action) {
    switch (action.type) {
      case "DATA_RECEIVED":
        return { ...state, data: action.value, loading: false };
      case "ERROR":
        return { ...state, error: action.error, loading: false };
      default:
        return state;
    }
  }

  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchCase(caseID);
        dispatch({ type: "DATA_RECEIVED", value: response });
      } catch (error) {
        dispatch({ type: "ERROR", error });
      }
    };
    fetchData();
  }, [caseID]);

  const { data, loading, error } = state;


  return (
    <>
      <DashboardLayout>
        <DashboardNavbar
          absolute
          light
          language={language}
          setLanguage={setLanguage}
        />
        <TemplateBox sx={{ pt: 2 }}>

            <div>
              <TemplateBox height="50px" />
              <Box
                sx={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <IconButton color="primary" onClick={handlePopUpButtonClick}>
                  <CallSplitIcon />
                </IconButton>
              </Box>

              <Container maxWidth="lg">
              {!loading && !error && data && data[0] ? (
                  <CaseDetailsContent data={data[0]} language={language}/>
                ) : loading ? (
                  <CaseDetailsContent loading data={[]} language={language}/>
                ) : (
                  <CaseDetailsContent data={[]} language={language}/>
                )}

                {error && <div>Error: {error.message}</div>}
              </Container>
            </div>
        </TemplateBox>
      </DashboardLayout>
    </>
  );
}

export default CaseDetailsFullscreen;
